import React from "react";
import styled, { withTheme } from "styled-components";
import { decimalPlaces } from "../../../helpers/mealsHelper";
import LoadingSpinner from "../../ui-library/LoadingSpinner/LoadingSpinner";

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Title = styled.label`
  font-size: 19px;
  font-weight: 600;
  color: ${(props) => props.theme?.nero};
  margin-bottom: 14px;
`;

const HeaderData = styled.div`
  display: flex;
  padding: 5px 5px 5px 0px;
  background: ${(props) => props.theme?.ivoryEgg};
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;
`;

const ItemLabelsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 5px;
  align-items: end;
  justify-content: space-between;
`;

const ItemLabelsLeftWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
`;

const ItemLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.color || props.theme?.mortar};
  flex: ${(props) =>
    props.length <= 21 ? "none" : props.showImpact && props.nWords > 3 ? 0 : 1};
`;

const ItemBarWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 17px;
`;

const ItemBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 17px;
  background-color: ${(props) => props.color || "#000000"};
  opacity: 0.13;
`;

const ItemValue = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme?.mortar};
`;

const ItemValueGrams = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: ${(props) => props.theme?.gray};
  margin-left: 3px;
`;

const ItemImpact = styled.span`
  font-size: 14px;
  font-weight: normal;
  color: ${(props) => props.theme?.gray};
  margin-left: 3px;
  flex: 1;
`;

const ItemProgressBar = styled.div`
  height: 17px;
  transition: width 1s;
  background-color: ${(props) => props.color || "#000000"};
  width: ${(props) => props.progress}%;
`;

const ItemProgressImpactBar = styled.div`
  height: 17px;
  background-color: ${(props) => props.color || "#000000"};
  opacity: 0.34;
  transition: width 1s;
  width: ${(props) => props.progress}%;
`;

const HorizontalProgressBarChart = ({ title, headerData, data }) => {
  return (
    <ComponentWrapper data-testid="horizontal-progress-chart">
      <Title>{title}</Title>
      <Wrapper>
        {headerData &&
          headerData.map((item, index) => (
            <HeaderData key={`header_key_${index}`}>
              <ItemLabel color={item.color}>{item.label}</ItemLabel>
              <ItemValue>{item.value}</ItemValue>
            </HeaderData>
          ))}
        {!data || data.length === 0 ? (
          <LoadingSpinner />
        ) : (
          data.map((item, index) => (
            <ItemWrapper key={`item_key_${index}`}>
              <ItemLabelsWrapper>
                <ItemLabelsLeftWrapper>
                  <ItemLabel
                    color={item.color}
                    length={item.label.length}
                    nWords={item.label.split(" ").length}
                    showImpact={!item.hideBar && item.impact}
                  >
                    {item.label}{" "}
                    {item.hideBar &&
                      `${Number(item.value).toFixed(decimalPlaces)}${
                        item.unit
                      }`}
                  </ItemLabel>
                  {!item.hideBar && item.impact && (
                    <ItemImpact>{`(${item.impact.sign}${Number(
                      item.impact.value
                    ).toFixed(decimalPlaces)}${item.unit})`}</ItemImpact>
                  )}
                </ItemLabelsLeftWrapper>
                {!item.hideBar && (
                  <ItemValue>
                    {`${Number(item.value).toFixed(decimalPlaces) || "0"}${
                      item.unit
                    }`}
                    <ItemValueGrams>{`(${Number(item.valueGrams || "0").toFixed(
                      decimalPlaces
                    )}g)`}</ItemValueGrams>
                  </ItemValue>
                )}
              </ItemLabelsWrapper>

              {!item.hideBar && (
                <ItemBarWrapper>
                  <ItemBar color={item.color} />
                  {!!item.value && (
                    <ItemProgressBar
                      color={item.color}
                      progress={item.value - (item.impact?.value ?? 0)}
                    />
                  )}
                  {!!item.impact && (
                    <ItemProgressImpactBar
                      color={item.color}
                      progress={item.impact.value}
                    />
                  )}
                </ItemBarWrapper>
              )}
            </ItemWrapper>
          ))
        )}
      </Wrapper>
    </ComponentWrapper>
  );
};

export default withTheme(HorizontalProgressBarChart);
